import React from "react";
import {
  SimpleShowLayout,
  TextField,
  NumberInput,
  BooleanInput
} from "react-admin";

const FormTab = (props) => {
  return (
    <SimpleShowLayout {...props}>
      <TextField source="baseball.id" />
      <NumberInput source="baseball.homeRuns" />
      <NumberInput source="baseball.doubles" />
      <NumberInput source="baseball.triples" />
      <BooleanInput source="baseball.isPitcher" />
    </SimpleShowLayout>
  );
};

export default FormTab;
